// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ObjectRefSelector-ObjectRefSelector-module__selectedEntities--ATnp6 {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 80px;
  overflow-x: auto;
  overflow-y: hidden;
}
.src-components-ObjectRefSelector-ObjectRefSelector-module__selectedEntitiesItemInner--vmTdf {
  display: flex;
  align-items: center;
  column-gap: 8px;
  background-color: #e3eeff;
  border-radius: 4px;
  color: #343a41;
  padding: 6px 12px;
}
.src-components-ObjectRefSelector-ObjectRefSelector-module__selectedEntitiesItemInner--vmTdf svg {
  color: black;
}
.src-components-ObjectRefSelector-ObjectRefSelector-module__select--UEjrN .ant-select-arrow {
  font-size: 20px;
  color: #f06326;
}
.src-components-ObjectRefSelector-ObjectRefSelector-module__select--UEjrN .ant-select-selector {
  padding-inline-end: 30px !important;
}
.src-components-ObjectRefSelector-ObjectRefSelector-module__entityLink--xbEy4 {
  color: #000000d9;
  text-decoration: underline;
  display: flex;
  column-gap: 8px;
}
.src-components-ObjectRefSelector-ObjectRefSelector-module__entityLink--xbEy4:hover {
  color: #e43d00;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/ObjectRefSelector/ObjectRefSelector.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AACF;AARA;EASI,YAAA;AAEJ;AAEA;EAEI,eAAA;EACA,cAAA;AADJ;AAFA;EAMI,mCAAA;AADJ;AAKA;EACE,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,eAAA;AAHF;AAIE;EACE,cAAA;EACA,0BAAA;AAFJ","sourcesContent":[".selectedEntities {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 80px;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.selectedEntitiesItemInner {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  background-color: #e3eeff;\n  border-radius: 4px;\n  color: #343a41;\n  padding: 6px 12px;\n  svg {\n    color: black;\n  }\n}\n\n.select {\n  :global(.ant-select-arrow) {\n    font-size: 20px;\n    color: #f06326;\n  }\n  :global(.ant-select-selector) {\n    padding-inline-end: 30px !important;\n  }\n}\n\n.entityLink {\n  color: #000000d9;\n  text-decoration: underline;\n  display: flex;\n  column-gap: 8px;\n  &:hover {\n    color: #e43d00;\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedEntities": `src-components-ObjectRefSelector-ObjectRefSelector-module__selectedEntities--ATnp6`,
	"selectedEntitiesItemInner": `src-components-ObjectRefSelector-ObjectRefSelector-module__selectedEntitiesItemInner--vmTdf`,
	"select": `src-components-ObjectRefSelector-ObjectRefSelector-module__select--UEjrN`,
	"entityLink": `src-components-ObjectRefSelector-ObjectRefSelector-module__entityLink--xbEy4`
};
export default ___CSS_LOADER_EXPORT___;
